"use strict";

exports.__esModule = true;
exports.OpenDashboardActionFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _vimanaTypes = require("@vimana/vimana-types");
var _API = require("../../API");
var _LayoutSelector = require("../../ConfigurableLayout/LayoutSelector");
var _Core = require("../../Core");
var _DashboardCollection = require("../../Dashboard/DashboardCollection");
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Controls for OpenDashboard
 */

var OpenDashboardActionFields = exports.OpenDashboardActionFields = function OpenDashboardActionFields(props) {
  var config = props.config,
    onChange = props.onChange;
  var dashboardID = config.dashboardID;
  var handleLayoutSelect = function handleLayoutSelect(selected) {
    onChange(Object.assign({}, config, {
      dashboardID: selected.length > 0 ? selected[0].id : undefined
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_DashboardCollection.DashboardCollection, null, function (collection) {
    return /*#__PURE__*/_react["default"].createElement(_API.CollectionSearcher, {
      collection: collection
    }, function (searcherProps) {
      return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, searcherProps, function (dashboard) {
        var selected = dashboardID ? [dashboardID] : [];
        return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
          label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "OpenDashboardActionFields.dashboard.label",
            defaultMessage: "Dashboard"
          }),
          helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "OpenDashboardActionFields.dashboard.helperText",
            defaultMessage: "The dashboard to open."
          })
        }, /*#__PURE__*/_react["default"].createElement(_LayoutSelector.LayoutSelector, {
          items: dashboard,
          selected: selected,
          placeholder: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "OpenDashboardActionFields.dashboard.placeholder",
            defaultMessage: "Select Dashboard"
          }),
          width: 300,
          onSelect: handleLayoutSelect
        }));
      });
    });
  });
};